const DoubleTabLike = ({ className, open,position }) => {
 
  return (
    <>
      {open && (
        <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 700" 
          style={{
            left: `${position.x}px`,
            top: `${position.y}px`,
          }}
          className={className}
          alt="doubleTabLike">
          <path d="M618.87,255.74c.42,19.41-3.1,37.96-9.79,54.89-46.66,129.49-244.34,261.65-258.66,271.1l-.41.26-.41-.26c-14.32-9.45-212-141.61-258.66-271.1-6.69-16.93-10.21-35.48-9.79-54.89,1.61-74.63,62.03-135.53,136.65-137.69,58.6-1.69,109.41,32.41,132.22,82.05,22.81-49.63,73.62-83.74,132.21-82.05,74.62,2.15,135.04,63.05,136.65,137.68Z" style={{ strokeWidth: "0px" }}/>
        </svg>
      )}
    </>
  );
};

export default DoubleTabLike;
